export default __webpack_public_path__ + "static/media/fire.57bd5e9e.mp3";